import React, {Component} from "react";
import {Link, withRouter} from "react-router-dom";
import {MDBContainer, MDBRow, MDBCol, MDBNavLink, MDBNavItem, MDBNavbarNav, MDBBtn} from "mdbreact";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy, faFileAlt, faFileArchive, faFileImage, faInbox, faStickyNote} from "@fortawesome/free-solid-svg-icons";
import classes from "./Portal.module.css";


class Portal extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {
        return (
            <MDBContainer>
                <MDBRow>

                    <Link to={{pathname: '/admin/new-article'}}>
                        <MDBBtn color='light'>
                            <FontAwesomeIcon icon={faStickyNote } className={classes.Icon}/>
                            <span className={classes.ButtonItemText}>新增文章</span>
                        </MDBBtn>

                    </Link>

                    <Link to={{pathname: '/admin/articleList'}}>
                        <MDBBtn color='light'>
                            <FontAwesomeIcon icon={faFileArchive} className={classes.Icon}/>
                            <span className={classes.ButtonItemText}>文章管理</span>
                        </MDBBtn>

                    </Link>

                    <Link to={{pathname: '/admin/banner'}}>
                        <MDBBtn color='light'>
                            <FontAwesomeIcon icon={faFileImage} className={classes.Icon}/>
                            <span className={classes.ButtonItemText}>橫額管理</span>
                        </MDBBtn>

                    </Link>

                    <Link to={{pathname: '/admin/admin-postList'}}>
                        <MDBBtn color='light'>
                            <FontAwesomeIcon icon={faCopy} className={classes.Icon}/>
                            <span className={classes.ButtonItemText}>貼文管理</span>
                        </MDBBtn>

                    </Link>

                    <Link to={{pathname: '/admin/pending-request'}}>
                        <MDBBtn color='light'>
                            <FontAwesomeIcon icon={faInbox} className={classes.Icon}/>
                            <span className={classes.ButtonItemText}>申請管理</span>
                        </MDBBtn>

                    </Link>

                </MDBRow>
            </MDBContainer>
        )
    }

}

export default withRouter(Portal)